import { EXTERNAL_LINKS } from 'core/links';

const Copyright = ({ align = "text-left" }) => {
    return (
        <div className={`copyright text-muted text-xs ${align} mt-2`}>
            {/* © {new Date().getFullYear()}{" "} */}
            Powered by <a
                className="font-weight-bold ml-1"
                href={EXTERNAL_LINKS.FHI_HOME}
                rel="noopener noreferrer"
                target="_blank"
            >
                Future Health Intelligence
            </a>
        </div>
    );
};

export default Copyright;